export default [
  {
    title: "압력용기 검사 시 주의사항",
    tableHeaderTitle: "검사 시 주의 사항",
    list: [
      {
        content: "가. 주변의 작업자에게 검사중임을 알리는 경고 표지를 준비하여 현장에 부착\n예) “출입금지”, “작동(운전, 조작) 금지”, “검사 중” 등",
        isChecked: "",
      },
      {
        content: "나. 용기 내부 관찰 및 내부 출입검사 시에는 용기 내부공기를 치환 후 산소농도 등을 측정 후 ⌜산업안전 보건기준에 관한규칙⌟ 제618조에서 규정하고 있는 적정공기 수준이상인 경우에 출입하여 검사를 실시한다.",
        isChecked: "",
      },
      {
        content: "다. 내부 출입검사 시에는 반드시 2인 이상이 실시함을 원칙으로 하고, 출입자는 개인보호구를 착용하고 검사를 실시한다.",
        isChecked: "",
      },
      {
        content: "라. 가연성 가스 또는 증기가 발생할 우려가 있는 장소에서는 방폭구조의 것을 사용한다.",
        isChecked: "",
      },
      {
        content: "마. 고소에서 안전밸브 작동시험을 할 때에는 분출구 반대방향에서 작동시험을 실시한다.",
        isChecked: "",
      },
      {
        content: "바. 안전장치는 고장일 수 있으므로 이를 항상 유념하여야 한다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "이름판",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 명판 확인 : 검사신청 대상과 설비의 일치여부 확인",
        content: "일반내용 확인(갑/을종, 용도, 형태)",
        isChecked: "",
      },
      {
        title: "1. 명판 확인 : 검사신청 대상과 설비의 일치여부 확인",
        content: "명판표시내용 확인(제조자, 제조년월일, 내경, 동체길이, 설계압력 또는 최대허용사용압력, 용량, 설계온도, 비파괴시험, 적용규격 등)\n» 내경(≒(둘레÷π)-(두께×2)), 동체길이 정보 없을 시 직접 측정 후 작성",
        isChecked: "",
      },
    ],
  },
  {
    title: "압력계 등",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 압력계 (기체나 액체를 관측할 수 있는 계측기기로 일반적으로 부르동관 압력계를 사용)",
        content: "사용 압력 확인",
        isChecked: "",
      },
      {
        title: "1. 압력계 (기체나 액체를 관측할 수 있는 계측기기로 일반적으로 부르동관 압력계를 사용)",
        content: "현저한 손상, 마모 및 누설 유무 확인",
        isChecked: "",
      },
      {
        title: "1. 압력계 (기체나 액체를 관측할 수 있는 계측기기로 일반적으로 부르동관 압력계를 사용)",
        content: "정확도 ± 5퍼센트 이내 여부 확인",
        isChecked: "",
      },
      {
        title: "2. 온도계",
        content: "유리 면 손상여부 확인",
        isChecked: "",
      },
      {
        title: "2. 온도계",
        content: "지시바늘 휘거나 떨림 여부 확인",
        isChecked: "",
      },
      {
        title: "3. 압력방출장치",
        content: "안전인증품 여부 확인 (액체의 압력을 개방하는 용도로 사용하는 안전밸브는 인증 대상 아님)",
        isChecked: "",
      },
      {
        title: "3. 압력방출장치",
        content: "현저한 손상, 부식, 마모, 유체 누출 유무 확인",
        isChecked: "",
      },
      {
        title: "3. 압력방출장치",
        content: "표지판 식별여부, 봉인상태 확인",
        isChecked: "",
      },
      {
        title: "3. 압력방출장치",
        content: "설정압력(Set Press.)은 설계압력 또는 최대 허용 사용압력 이하인지 확인",
        isChecked: "",
      },
    ],
  },
  {
    title: "외관 검사 및 두께측정",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 외관상태",
        content: "경판의 형태 확인",
        isChecked: "",
      },
      {
        title: "1. 외관상태",
        content: "본체, 노즐, 맨홀, 부속물 등 손상, 변형, 깨짐, 부식 등 발생 유무 확인\n" +
          "» 부식 및 마모의 가능성이 높은 곳 : 기계적인 가공, 용접 등으로 잔류응력이 남아 있는 경판의 너클부위,입출구 노즐 및 근처의 동체 및 경판\n" +
          "» 배관, 소켓 등 임의적 변경 설치 또는 노즐 보강판 테스트홀 정상여부 확인",
        isChecked: "",
      },
      {
        title: "1. 외관상태",
        content: "용접이음부, 노즐부, 플랜지, 맨홀에 누설 흔적 유무 및 볼트/너트 체결상태 확인\n" +
          "» 가스켓 손상, 탈락, 불량에 따른 leak 등 확인\n" +
          "» 볼트 및 너트 풀림, 나사 파손, 체결상태, 나사산 여유 수 등 적정여부 확인",
        isChecked: "",
      },
      {
        title: "1. 외관상태",
        content: "용기에 부착되어져 사용하고 있는 사다리 설치 상태 등 확인",
        isChecked: "",
      },
      {
        title: "2. 용접이음부",
        content: "균열 또는 이상 유무 육안 확인(필요 시 액체침투탐상 또는 자분탐상검사 실시)\n" +
          "» 위 검사방법에 의해 발견된 이상부위는 초음파탐상검사를 실시",
        isChecked: "",
      },
      {
        title: "3. 두께측정",
        content: "측정 전 재질에 따른 특성을 고려하여 시험편을 이용하여 교정 실시",
        isChecked: "",
      },
      {
        title: "3. 두께측정",
        content: "동체 및 경판의 두께를 측정하고 그 값이 필요두께(부식여유 제외) 이상인지 확인",
        isChecked: "",
      },
      {
        title: "4. 내면",
        content: "심한 손상, 변형, 깨짐, 부식상태 확인(필요 시 용기를 개방하여 확인)",
        isChecked: "",
      },
    ],
  },
  {
    title: "지지대, 응축수, 접지 등",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 지지대 및 기초볼트",
        content: "외력에 의한 지지대의 손상 및 변형, 부식 유무 확인\n" +
          "» 지지대 종류 : 스커트, 새들, 레그, 러그형",
        isChecked: "",
      },
      {
        title: "2. 응축수",
        titleInfo: "응축수 발생원인과 문제점 및 해결방안",
        content: "하부 드레인 밸브 설치 부분의 부식 및 작동 상태 확인",
        isChecked: "",
      },
      {
        title: "2. 응축수",
        content: "드레인 밸브를 조작하여 응축수 방출 여부 확인)",
        isChecked: "",
      },
      {
        title: "3. 접지편(을종용기 제외)",
        content: "압력용기의 받침대 하단에 최소 1개 이상 견고히 접속되어 있는지 확인",
        isChecked: "",
      },
      {
        title: "3. 접지편(을종용기 제외)",
        content: "접지편의 부식으로 인한 기능상실 여부 확인\n" +
          "» 접지저항 증가 방지를 위해 6㎜ 이상의 스테인레스 철판을 사용 가",
        isChecked: "",
      },
    ],
  },
];
